import { ButtonRoundLg } from '@apps-common/components/elements'
import { ModalButton } from '@apps-common/components/modals/ModalButton'
import { QrCodeUnitLabelModal } from '@apps-common/components/qr-code/qr-code-unit-label/QrCodeUnitLabelModal'
import { commonIcons } from '@apps-common/config/icons'
import { modalFadeInEnterAnimation, modalFadeInLeaveAnimation } from '@apps-common/lib/modal-animations'

interface IProps {
  loading?: boolean
  unitId?: string
}

export const QRCodeUnitLabelButton: React.FC<IProps> = ({ loading, unitId }) => (
  <ModalButton
    component={QrCodeUnitLabelModal}
    disabled={loading}
    componentProps={{ unitId }}
    enterAnimation={modalFadeInEnterAnimation}
    leaveAnimation={modalFadeInLeaveAnimation}
    backdropDismiss
  >
    <ButtonRoundLg
      type='div'
      loading={loading}
      disabled={loading}
      className='action-brand'
      tooltip={{ id: 'device-label-qr-code', place: 'bottom', message: 'QR Code' }}
    >
      <commonIcons.qrCodeUnitLabel />
    </ButtonRoundLg>
  </ModalButton>
)
